// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page-layout {
  align-items: center;
  max-width: auto;
  background-color: aliceblue;
}

h1 {
  font-size: 24px;
  font-weight: bold;
}

.about-us p {
  font-size: 18px;
  /* Adjust the font size as needed */
  /* Add any other styles as needed */
}


.about-us {
  align-items: center;
  border-radius: 3px;
  justify-content: center;
  justify-items: center;
  display: flex;
  text-align: center;
  justify-content: center;
  margin: 20px 0;
}

.about-image {
  justify-content: center;
  justify-items: center;
  align-items: center;
  width: 300px;
  /* Ensures the image takes up 100% of its container's width */
  height: 250px;
  /* Maintains the image's aspect ratio */
  display: block;
  /* Removes any extra space reserved for descenders */
  margin: 0 auto;
  /* Centers the image horizontally */
}

.about-p-button {
  max-width: 700px;
}

.learn-more-button {
  justify-content: center;
  justify-items: center;
  align-items: center;
  background-color: #78c271;
  /* Button background color */
  color: white;
  /* Button text color */
  padding: 10px 20px;
  /* Adjust padding as needed */
  border: none;
  border-radius: 5px;
  /* Adjust border radius as needed */
  cursor: pointer;
  margin-top: 20px;
  /* Adjust margin as needed */
}

.learn-more-button:hover {
  background-color: #134b1a;
  /* Button background color on hover */
}

/* Responsive Styles */
@media (max-width: 768px) {
  h1 {
    font-size: 20px;
  }

  .about-image {
    width: 120px;
    display: none;

  }

  .learn-more {
    display: block;
    width: 330px;
    max-width: auto;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/FrontEnd/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,mCAAmC;AACrC;;;AAGA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,6DAA6D;EAC7D,aAAa;EACb,uCAAuC;EACvC,cAAc;EACd,oDAAoD;EACpD,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;;EAEf;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".home-page-layout {\n  align-items: center;\n  max-width: auto;\n  background-color: aliceblue;\n}\n\nh1 {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.about-us p {\n  font-size: 18px;\n  /* Adjust the font size as needed */\n  /* Add any other styles as needed */\n}\n\n\n.about-us {\n  align-items: center;\n  border-radius: 3px;\n  justify-content: center;\n  justify-items: center;\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  margin: 20px 0;\n}\n\n.about-image {\n  justify-content: center;\n  justify-items: center;\n  align-items: center;\n  width: 300px;\n  /* Ensures the image takes up 100% of its container's width */\n  height: 250px;\n  /* Maintains the image's aspect ratio */\n  display: block;\n  /* Removes any extra space reserved for descenders */\n  margin: 0 auto;\n  /* Centers the image horizontally */\n}\n\n.about-p-button {\n  max-width: 700px;\n}\n\n.learn-more-button {\n  justify-content: center;\n  justify-items: center;\n  align-items: center;\n  background-color: #78c271;\n  /* Button background color */\n  color: white;\n  /* Button text color */\n  padding: 10px 20px;\n  /* Adjust padding as needed */\n  border: none;\n  border-radius: 5px;\n  /* Adjust border radius as needed */\n  cursor: pointer;\n  margin-top: 20px;\n  /* Adjust margin as needed */\n}\n\n.learn-more-button:hover {\n  background-color: #134b1a;\n  /* Button background color on hover */\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  h1 {\n    font-size: 20px;\n  }\n\n  .about-image {\n    width: 120px;\n    display: none;\n\n  }\n\n  .learn-more {\n    display: block;\n    width: 330px;\n    max-width: auto;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
